// Bill constants should match the backend
export var BILL_FACTS = {
  MY_BILLS: 'my_bills',
  SUGGESTED_BILLS: 'my_bills_suggested'
};
export var BILL_FREQUENCIES = {
  WEEKLY: 'WEEKLY',
  EVERY_OTHER_WEEK: 'EVERY_OTHER_WEEK',
  MONTHLY: 'MONTHLY',
  EVERY_OTHER_MONTH: 'EVERY_OTHER_MONTH',
  QUARTERLY: 'QUARTERLY',
  TWICE_A_YEAR: 'TWICE_A_YEAR',
  ANNUALLY: 'ANNUALLY',
  ONE_TIME: 'ONE_TIME'
};
export var BILL_CATEGORIES = {
  ENTERTAINMENT: 'ENTERTAINMENT',
  FEES: 'FEES',
  GROCERIES: 'GROCERIES',
  HEALTH: 'HEALTH',
  HOUSING: 'HOUSING',
  OTHER: 'OTHER',
  RESTAURANTS: 'RESTAURANTS',
  SHOPPING: 'SHOPPING',
  TRANSPORT: 'TRANSPORT',
  TRAVEL: 'TRAVEL',
  UTILITIES: 'UTILITIES'
};
export var BILL_SUBCATEGORIES = {
  INSURANCE: 'INSURANCE',
  LOAN: 'LOAN',
  NONE: null
};
export var CANONICAL_BILLER_NAMES = {
  APPLE: 'APPLE',
  ATT: 'ATT',
  CAPITAL_ONE: 'CAPITAL_ONE',
  COMCAST: 'COMCAST',
  COX: 'COX',
  GEICO: 'GEICO',
  NAVIENT: 'NAVIENT',
  NETFLIX: 'NETFLIX',
  SALLIE_MAE: 'SALLIE_MAE',
  SPOTIFY: 'SPOTIFY',
  SPRINT: 'SPRINT',
  STATE_FARM: 'STATE_FARM',
  T_MOBILE: 'T_MOBILE',
  VENMO: 'VENMO',
  VERIZON: 'VERIZON',
  XFINITY: 'XFINITY'
};